import { combineReducers } from 'redux'
import { createProfile } from './create'
import { restoreProfile } from './restore'
import { walletProfile } from './wallet'
import { backupProfile } from './backup'
import { receiveProfile } from './receive'
import { storageProfile } from './storage'
import { unlockProfile } from './unlock'
import { pwdChangeProfile } from './passwordChange'

export const walletReducer = combineReducers({
  createProfile,
  restoreProfile,
  walletProfile,
  backupProfile,
  receiveProfile,
  storageProfile,
  unlockProfile,
  pwdChangeProfile
})



// WEBPACK FOOTER //
// ./src/store/reducers/wallet/index.js